import { NgModule } from '@angular/core';
import { AdministrationHomeModule } from './administration-home.module';
import { EmpusaMicroAppType } from '@empusa/empusa-core';

@NgModule({
  declarations: [],
  imports: [],
  exports: []
})
export class AdministrationModule {
  name: string = "administration";
  description: string = "Administración"
  icon: string = "administration";
  page: any = AdministrationHomeModule;
  homeApp: boolean = false;
  path: string = "administration";
  order: number = 1;
  resourceServerId: string = "keycloak-auth-manager-resources-server";
  appType: EmpusaMicroAppType = EmpusaMicroAppType.normal;

  constructor() {
    //we register ourselves
    (<any>window).empusa(this);
    console.debug("Load microapp " + this.name);
  }
}
